angular.module('picmonicng').directive('uiSlider', [
  '$filter',
  function ($filter) {
    return {
      restrict: 'E',
      template:
        '<div class="slider-wrapper"><div class="slider-filler"></div><div class="slider-handle" ng-style="{width: (((ngModel - minValue > valueDifference ? valueDifference: ngModel - minValue) / valueDifference) * 100) + \'%\'}"><div class="scrub-handle"></div></div> </div></div>',
      require: 'ngModel',
      replace: true,
      scope: {
        minValue: '=',
        maxValue: '=',
        ngModel: '=',
        keyOffset: '=',
        onChange: '&',
        onComplete: '&',
        type: '@',
      },
      controller: [
        '$scope',
        function ($scope) {
          $scope.minValue = $scope.minValue ? $scope.minValue : 0;
          $scope.maxValue = $scope.maxValue ? $scope.maxValue : 100;
        },
      ],
      link: function (scope, element, attrs, ngModel) {
        var scrubHandle = element.find('.scrub-handle');

        var dragStop = function (e) {
          scope.$apply(function () {
            setNewValue(e);
          });
        };

        scrubHandle.draggable({
          axis: 'x',
          containment: '.slider-wrapper',
          refreshPositions: true,
          stop: dragStop,
        });

        scope.valueDifference = scope.maxValue - scope.minValue;

        element.bind('mousedown', function () {
          element.bind('mousemove, mouseup', function (e) {
            scope.$apply(function () {
              setNewValue(e);
            });
          });

          angular.element('body').on('mouseup', completeFunction);
        });

        element.bind('click', function (e) {
          scope.$apply(function () {
            setNewValue(e);
          });
        });

        // Support adjusting volume with arrow left and right
        element.bind('keydown', function (e) {
          if (element.is(':focus')) {
            var keyOffset = scope.type == 'integer' ? 1 : 0.1;
            var currentValue = parseFloat(ngModel.$viewValue);
            if (e.keyCode == 39) {
              ngModel.$setViewValue(
                currentValue < scope.maxValue - keyOffset ? currentValue + keyOffset : scope.maxValue
              );
            } else if (e.keyCode == 37) {
              ngModel.$setViewValue(currentValue > scope.minValue ? currentValue - keyOffset : scope.minValue);
            }

            if (typeof scope.onChange == 'function') {
              scope.onChange();
            }
          }
        });

        var completeFunction = function () {
          element.unbind('mousemove, mouseup');

          if (typeof scope.onComplete == 'function') {
            scope.onComplete();
          }

          angular.element('body').unbind('mouseup', completeFunction);
        };

        var setNewValue = function (e) {
          var maxWidth = element.width();

          var percentage = (e.pageX - element[0].getBoundingClientRect().left) / maxWidth;

          var newValue = Math.round((scope.minValue + scope.valueDifference * percentage) * 100) / 100;

          switch (scope.type) {
            case 'integer':
              newValue = $filter('integer')(newValue);
              break;
          }

          newValue = newValue < scope.minValue ? scope.minValue : newValue > scope.maxValue ? scope.maxValue : newValue;

          ngModel.$setViewValue(newValue);
          scrubHandle.css('left', '');
          scrubHandle.css('right', '0px');

          if (typeof scope.onChange == 'function') {
            scope.onChange();
          }
        };
      },
    };
  },
]);
